import request from '@/utils/request'

export function getQuickMenuList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/quickMenu.listQuickMenus',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '获取快捷功能列表失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

export function addQuickMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/quickMenu.saveQuickMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '新增快捷功能失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateQuickMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/quickMenu.updateQuickMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '修改快捷功能失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteQuickMenu(caId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/quickMenu.deleteQuickMenu',
      method: 'post',
      data: { caId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || '删除快捷功能失败'))
    }).catch(error => {
      reject(error)
    })
  })
}